import theme from 'theme'

const BANNERS = {
  PARTNER:
    'Os fornecedores são as organizações com as quais você possui vínculo e compartilha dados pessoais. Nesta seção, você pode fazer o acompanhamento e gestão das conformidades, riscos, relatórios e demais informações associadas.',
  QUESTIONNAIRES_RECEIVED:
    'Aqui são exibidos os questionários que sua organização precisa responder, solicitados por outras empresas que desejam avaliar a sua conformidade.',
  SUGGESTION:
    'O módulo de gestão de fornecedores está conectado ao seu mapeamento de processos. Sempre que um fornecedor aparecer no mapeamento, mas ainda não tiver registro de avaliação, ele será exibido aqui como uma sugestão.',
  PRE_AVALIATION:
    'A pré-avaliação permite que sua organização avalie a conformidade das empresas antes de contratá-las.',
}

const REGISTER_TYPES = {
  REGISTER: 'register',
  IMPORT: 'import',
  PRE_AVALIATION: 'preAvaliation',
}

const RISKS = {
  UNDEFINED: {
    value: 0,
    color: theme.palette.fragility.undefined,
    label: 'Indefinido',
    enum: 'undefined',
  },
  LOW: {
    value: 1,
    color: theme.palette.fragility.low,
    label: 'Baixo',
    enum: 'low',
  },
  MEDIUM: {
    value: 2,
    color: theme.palette.fragility.medium,
    label: 'Médio',
    enum: 'medium',
  },
  HIGH: {
    value: 3,
    color: theme.palette.fragility.high,
    label: 'Alto',
    enum: 'high',
  },
  SEVERE: {
    value: 4,
    color: theme.palette.fragility.severe,
    label: 'Severo',
    enum: 'severe',
  },
}

const RISKS_LIST = Object.values(RISKS)

const SUPPLIER_AUDIT_FREQUENCY_TYPES = [
  { id: 'days', name: 'Dia(s)' },
  { id: 'months', name: 'Mês(es)' },
  { id: 'years', name: 'Ano(s)' },
]

const thirdPartyManagements = {
  BANNERS,
  REGISTER_TYPES,
  RISKS_LIST,
  RISKS,
  SUPPLIER_AUDIT_FREQUENCY_TYPES,
}

export default thirdPartyManagements
